module.exports = __webpack_public_path__ + "static/Full Harvest-4a7f4f1c3f5588ca3eae82841042a1ff.jpg";